namespace SP {

    export function createElement(elementName: string, attrs: any = null)  {

        var el = document.createElement(elementName);

        if (attrs != null)
        for (var key in attrs) {
            (el as any)[key] = attrs[key];
        }

        return el;
    }
}